import React from "react" ;
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Globals } from "root/DataFunctions/BaseDataFns";
import {getDocumentUrl, getUserImageUrl} from "root/DataFunctions/CommonDataFns";
import tempImg2 from '../assets/icons/calendar.png';
import {UserTypeName} from "root/DataFunctions/Constants";

const GalleryItem = ({ gallery, image, setIndexFromPost, postIndex }) => {
    const { title, firstname, surname, event_date, posted_by_name, unenc_recipient_user_id, unenc_sender_user_id } = gallery;

    //pick out the first image
    const document_id = image;
    const url = getDocumentUrl(document_id);
    const isFromMe = unenc_recipient_user_id === unenc_sender_user_id ? true : false;


    //Sender image/avatar for rollover
    const getGalleryUserImageUrl = (  ) =>
    {
        let url = '';

        if(gallery.posted_by_name === 'Me'){
            url = Globals.APIFolder + '/user/' + gallery.sender_user_id + '/avatar?thumb&size=100';
        }
        else{
            const urserImage = gallery.typeName === UserTypeName.BIRTH_PARENT ? null : gallery.user_image;
            url = getUserImageUrl(urserImage, 50,true);
        }

        return url;
    }
    
    return (
        <div onClick={() => setIndexFromPost(postIndex)} className="gallery-card-outer">
            <div
                className="gallery-card"
                style={{backgroundImage: `url(${url})`}}
            >
                <div className="gallery-card-content">
                    <div className="gallery-card-inner-content">
                        <h3 className="gallery-card-title">{title}</h3>
                        <div className="gallery-card-icons">
                            <OverlayTrigger
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-right">
                                        Event date <strong>{event_date}</strong>.
                                    </Tooltip>
                                }
                            >
                                <img className="gallery-card-icon" src={tempImg2} alt="temp 2"/>
                            </OverlayTrigger>

                            <OverlayTrigger
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-right">
                                        Posted by
                                        <strong>
                                            {isFromMe && ' ME'}
                                            {!isFromMe && ' ' + posted_by_name}
                                        </strong>
                                    </Tooltip>
                                }
                            >

                                <img className="gallery-card-icon" src={getGalleryUserImageUrl()} alt="sender image"/>

                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GalleryItem;
